export default __webpack_public_path__ + "static/media/srch.35c085ea.png";